import adjustViewport from './function/adjustViewport';
import HeaderMenu from './module/HeaderMenu';
import HeaderDrawer from './module/HeaderDrawer';
import ScrollAnimation from './module/ScrollAnimation';
import Slider from './module/Slider';
import RecruitFilterToggle from './module/RecruitFilterToggle';
import StickyCtaBar from './module/StickyCtaBar';
import HeroBgFade from './module/HeroBgFade';
import ApplicationForm from './module/ApplicationForm';
import ContactForm from './module/ContactForm';
import ArchiveRecruit from './page/archive-recruit';
import ApplicationConfirmPage from './page/application-confirm';
import ContactConfirmPage from './page/contact-confirm';

const init = () => {
  // TOP ヒーロー背景フェード
  (() => {
    const heroBgFade = new HeroBgFade();
    heroBgFade.init();
  })();

  // ドロップダウンメニュー（HeaderMenu）
  (() => {
    const headerMenu = new HeaderMenu();
    headerMenu.init();
  })();

  // スマホ：ハンバーガーフルスクリーンメニュー
  (() => {
    const headerDrawer = new HeaderDrawer();
    headerDrawer.init();
  })();

  // スクロールアニメーション
  (() => {
    const scrollAnimation = new ScrollAnimation();
    scrollAnimation.init();
  })();

  // 共通スライダー c-slider（`[data-js-c-slider]`、4件以上で Swiper）
  (() => {
    const slider = new Slider();
    slider.init();
  })();

  // 紹介求人情報：絞り込みパネル開閉
  (() => {
    const recruitFilterToggle = new RecruitFilterToggle();
    recruitFilterToggle.init();
  })();

  // 下端追従 CTA（求人詳細など）
  (() => {
    const stickyCtaBar = new StickyCtaBar();
    stickyCtaBar.init();
  })();

  // 応募フォーム（静的バリデーション）
  (() => {
    const applicationForm = new ApplicationForm();
    applicationForm.init();
  })();

  // お問合せフォーム（静的バリデーション）
  (() => {
    const contactForm = new ContactForm();
    contactForm.init();
  })();

  // 紹介求人情報アーカイブ
  (() => {
    const archiveRecruit = new ArchiveRecruit();
    archiveRecruit.init();
  })();

  // 応募フォーム確認画面
  (() => {
    const applicationConfirmPage = new ApplicationConfirmPage();
    applicationConfirmPage.init();
  })();

  // お問合せフォーム確認画面
  (() => {
    const contactConfirmPage = new ContactConfirmPage();
    contactConfirmPage.init();
  })();
};

const bootstrap = () => {
  adjustViewport();
  init();
};

if (document.readyState === 'loading') {
  window.addEventListener('DOMContentLoaded', bootstrap);
} else {
  bootstrap();
}
